import { useEffect, useRef, useState } from 'react';

// `lottie-web` (~250 KB) is loaded on demand so it stays out of the login bundle, and
// `prefers-reduced-motion` skips the load entirely rather than freezing a frame.
// The JSON was edited to drop its Google Fonts URL; the font is loaded locally instead.
const LoginAnimation = () => {
    const boite = useRef<HTMLDivElement>(null);
    const [pret, setPret] = useState(false);

    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        let animation: { destroy: () => void } | null = null;
        let abandonne = false;

        void (async () => {
            try {
                const [{ default: lottie }, { default: donnees }] = await Promise.all([
                    import('lottie-web/build/player/lottie_light'),
                    import('../../assets/lottie-connexion.json'),
                ]);

                // Bail if unmounted during the load, to avoid a loop on a detached node.
                if (abandonne || !boite.current) {
                    return;
                }

                animation = lottie.loadAnimation({
                    container: boite.current,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    animationData: donnees,
                });
                setPret(true);
            } catch {
                // Load failed: the column keeps its blue fill, nothing to tell the reader.
            }
        })();

        return () => {
            abandonne = true;
            animation?.destroy();
        };
    }, []);

    return (
        <div
            ref={boite}
            className={`login-animation${pret ? ' login-animation--pret' : ''}`}
            aria-hidden="true"
        />
    );
};

export default LoginAnimation;
